import { useEffect, useState } from "react";
import { PollOption } from "@infrastructure/Services/PostService.types";
import { getLocalStoragePolls } from "@infrastructure/Persistence/LocalUserStorage";
import { PostIdType } from "../Post.types";

export function usePollsState(
    initialPollOptions: PollOption[],
    pollOptionHandler: (
        pollOptionId: number,
        type: "create" | "delete",
    ) => Promise<void>,
    postId: PostIdType,
) {
    const [totalResponseCount, setTotalResponseCount] = useState<number>(0);
    const [pollOptions, setPollOptions] =
        useState<PollOption[]>(initialPollOptions);
    const [hasParticipated, setHasParticipated] = useState(false);
    const [userOptionId, setUserOptionId] = useState<number>();
    const [quizAnswerOptionId, setQuizAnswerOptionId] = useState<number>();
    const userPolls = getLocalStoragePolls();
    useEffect(() => {
        const currentTotalCount = pollOptions.reduce(
            (total, postOption) => total + postOption.responsesCount,
            0,
        );
        setTotalResponseCount(currentTotalCount);
    }, [postId, pollOptions]);

    useEffect(() => {
        setPollOptions(initialPollOptions);
    }, [initialPollOptions]);
    useEffect(() => {
        const userPollDetails = getLocalStoragePolls().find(
            (poll) => poll.postId === postId,
        );

        if (!userPollDetails) {
            setUserOptionId(undefined);
            setQuizAnswerOptionId(undefined);
            setHasParticipated(false);
        } else {
            setUserOptionId(userPollDetails.optionId);
            setQuizAnswerOptionId(userPollDetails.quizAnswerOptionId);
            setHasParticipated(true);
        }
    }, [postId, userPolls]);

    const handlePollOptionClick = (
        pollOptionId: number,
        type: "create" | "delete",
    ) => {
        pollOptionHandler(pollOptionId, type);
    };

    return {
        totalResponseCount,
        handlePollOptionClick,
        pollOptions,
        hasParticipated,
        userOptionId,
        quizAnswerOptionId,
        resetPollOptions: setPollOptions,
    };
}

export function calculateAverage(ratings: PollOption[]): number {
    let count = 0;
    let sum = 0;

    ratings.forEach((rating) => {
        count += rating.responsesCount;
        sum += rating.responsesCount * parseInt(rating.content);
    });

    return count > 0 ? sum / count : 0;
}

export function getUserRating(
    ratings: PollOption[],
    userOptionId: number | undefined,
): number | undefined {
    const foundRating = ratings.find(({ id }) => userOptionId === id);
    return foundRating ? parseInt(foundRating.content) : undefined;
}
